import { useState } from 'react';
import { useAuth } from '../firebase/AuthProvider';

export function SignIn() {
  const { signIn, error } = useAuth();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [busy, setBusy] = useState(false);

  return (
    <main className="centered">
      <form
        className="card signin"
        onSubmit={async (event) => {
          event.preventDefault();
          setBusy(true);
          try { await signIn(email.trim(), password); } catch { /* surfaced via error */ }
          finally { setBusy(false); }
        }}
      >
        <h1>Sign in</h1>
        <p className="muted">Certification for sales representatives.</p>

        <label htmlFor="email">Email</label>
        <input
          id="email" type="email" autoComplete="username" required
          value={email} onChange={(e) => setEmail(e.target.value)}
        />

        <label htmlFor="password">Password</label>
        <input
          id="password" type="password" autoComplete="current-password" required
          value={password} onChange={(e) => setPassword(e.target.value)}
        />

        {error && <p className="error" role="alert">{error}</p>}

        <button type="submit" className="primary" disabled={busy}>
          {busy ? 'Signing in…' : 'Sign in'}
        </button>
        <p className="muted small">
          Your session lasts only as long as this tab stays open.
        </p>
      </form>
    </main>
  );
}
